export enum Modal {
    AssignTaskToUser,
    SetTaskState,
}
